export default __webpack_public_path__ + "1c48c60b7486ed69f65333ecb0744150.jpg";